module.exports = __webpack_public_path__ + "35c73f4e2587f20202e93078e2dec62a.pdf";